module.exports = __webpack_public_path__ + "static/media/property.55c68381.png";